class StartYourProject {

  constructor () {
    this.container          = document.getElementById('start-your-project');
    this.btnToggles         = document.querySelectorAll('[data-toggle-start-project]');
    this.btnClose           = document.getElementById('start-your-project-close');
    this.handleToggleClick  = this.handleToggleClick.bind(this);
    this.handleCloseClick   = this.handleCloseClick.bind(this);
  }

  handleToggleClick (e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.container.classList.contains('active')) {
      this.container.classList.remove('active');
    } 
    else {
      this.container.classList.add('active');
    }
  }

  handleCloseClick (e) {
    e.preventDefault();
    e.stopPropagation();
    this.container.classList.remove('active');
  }

  init () {
    if (this.btnOpen) {
      this.btnOpen.addEventListener('click', this.handleOpenClick);
    }
    if (this.btnClose) {
      this.btnClose.addEventListener('click', this.handleCloseClick);
    }
    if (this.container) {
        //this.container.addEventListener('mouseout', this.handleCloseClick);
    }

    if (this.btnToggles.length > 0) {
      this.btnToggles.forEach((btn) => {
        btn.addEventListener('click', this.handleToggleClick);
      });
    }
  }
}

export default function () {
  const obj = new StartYourProject();
  obj.init()
  return obj;
}
